import type { Dispatch } from "react";
import type { EditorAction } from "../editor/reducers";
import { AccessButton } from "@acdc2/ui/components/access-button";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Form } from "@acdc2/ui/components/access-form";
import { cn } from "@acdc2/ui/lib/utils";

type Props = {
  onSubmit: (event: React.FormEvent) => Promise<boolean>;
  dispatch: Dispatch<EditorAction>;
  children?: React.ReactNode;
  className?: string;
};

export function RegionUpdateForm({
  onSubmit,
  dispatch,
  children,
  className,
}: Props) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const submit = async (event: React.FormEvent) => {
    setLoading(true);
    try {
      const success = await onSubmit(event);
      if (success) {
        dispatch({
          type: "switchToCommonTab",
          tab: "regions",
        });
      }
    } catch (error) {
      console.error("Failed to submit region update form:", error);
    }
    setLoading(false);
  };

  return (
    <Form
      className={cn("p-4 flex flex-col gap-4", className)}
      onSubmit={submit}
    >
      {children}
      <AccessButton type="submit" loading={loading} disabled={loading}>
        {t("RegionUpdateForm.labels.save")}
      </AccessButton>
    </Form>
  );
}
